import { render } from "./InfantList.vue?vue&type=template&id=2311aa97"
import script from "./InfantList.vue?vue&type=script&lang=js"
export * from "./InfantList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__